import { render, staticRenderFns } from "./BossDBCitationGuidance.vue?vue&type=template&id=2b8e3703&scoped=true&"
import script from "./BossDBCitationGuidance.vue?vue&type=script&lang=js&"
export * from "./BossDBCitationGuidance.vue?vue&type=script&lang=js&"
import style0 from "./BossDBCitationGuidance.vue?vue&type=style&index=0&id=2b8e3703&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8e3703",
  null
  
)

export default component.exports